import Vue from 'vue';
import VueRouter from 'vue-router'
import fastClick from 'fastclick'

import App from './App'
import router from './routes'
import filter from './plugins/filter'

Vue.use(filter)

Vue.use(VueRouter)
new (Vue.extend(App))({
  router,
}).$mount('#app')

fastClick.attach(document.body)



// WEBPACK FOOTER //
// ./src/main.js